<template>
    <div >
        <div class="items-list"><router-view/></div>
        <div class="items" :style="{'width': withItems +'px'}">
            <div class="item" :class="{'active': item === 'lista'}" @click="$router.push('/listas')">
                Todas
            </div>
            <div class="item" :class="{'active': item === 'aprobadas'}" @click="$router.push('/listas/aprobadas')">
                Modelos activas
            </div>
            <div class="item" :class="{'active': item === 'pendientes'}" @click="$router.push('/listas/pendientes')">
                Modelos pendientes
            </div>
            <div class="item" :class="{'active': item === 'bloqueadas'}" @click="$router.push('/listas/bloqueadas')">
                Modelos Retiradas
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'items',
    data() {
        return {
            withItems: window.innerWidth - 350,
            item: null
        }
    },
    mounted() {
        this.item = this.$route.name
        if (!this.$store.state.constants.COLLAPSE) {
            this.withItems = window.innerWidth - 80
        } else {
            this.withItems = window.innerWidth - 350
        }
        this.$root.$on('collapse', (block) => {
            if (block) {
                this.withItems = window.innerWidth - 350
            } else {
                this.withItems = window.innerWidth - 80
            }
        })
        this.$root.$on('changeList', (block) => {
            this.item = block
        })
    }
}
</script>

<style scoped>
    .items {
        position: fixed;
        text-align: center;
        display: flex;
        transition: width 1s;
    }
    .item {
        background-color: #e0b059;
        width: 25%;
        padding: 20px;
        color: #fff;
        font-weight: bolder;
        border-style: outset;
        min-height: 12vh;
    }
    .active{
        border-style: inset;
        background-color: #fff;
        color: #e0b059;
    }
    .item:hover {
        border-style: double;
        border-color: black;
    }
    .items-list {
       width: 100%;
       min-height: 78vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Modelos/Listas/ListItems.vue